export function createRouteMeta({
    middleware = 'auth',
    requiresWorkspace = false,
    requiresAdmin = false,
    requiresCustomerScope = false,
    requiredCapability = null,
} = {}) {
    const meta = {
        middleware,
    };

    if (requiresWorkspace) {
        meta.requires_workspace = true;
    }

    if (requiresAdmin) {
        meta.requires_admin = true;
    }

    if (requiresCustomerScope) {
        meta.requires_customer_scope = true;
    }

    if (requiredCapability) {
        meta.required_capability = requiredCapability;
    }

    return meta;
}

export function customerRouteMeta(options = {}) {
    return createRouteMeta({
        requiresCustomerScope: true,
        ...options,
    });
}

export function workspaceRouteMeta(requiredCapability = null, options = {}) {
    return createRouteMeta({
        requiresWorkspace: true,
        requiredCapability,
        ...options,
    });
}

export function workspaceAdminRouteMeta(requiredCapability = null, options = {}) {
    return createRouteMeta({
        requiresWorkspace: true,
        requiresAdmin: true,
        requiredCapability,
        ...options,
    });
}
